import type { Item } from "@wayflyer/flyui";

export const formatAddressValueLabel = ({ text, subText }: Item): string => {
  if (typeof subText !== "string" || !subText || text.includes(subText)) {
    return text;
  }

  return `${text}, ${subText}`;
};
